// export view component as lowercase
// lowercase key used in setting view state id
// exported key name must be a valid view id
import { Start as start } from './start';
import { Projects as projects } from './projects';
import { Design as design } from './design';
// we use the default export as view lookup in App
const views = { start, projects, design };
export default views;
